import { useState, useEffect } from "react";
import { Card, Container, Input, FormButton, Text, Checkbox } from "../UI"
import { useForm, Controller } from "react-hook-form";
import { useUserData } from "../../hooks/useUserData";
import { Classes } from "../../theme/Classes";
import PasswordStrengthBar from 'react-password-strength-bar';
import { useController } from "../../hooks/useController";
import { APP_SETTINGS } from "../../hooks/useAppSettings";

export const ChangePassword = ( {setOpen}) => {
    const { handleSubmit, control, formState: { errors }, getValues } = useForm({ mode: 'onChange' });
    const {lang, token} = useUserData();
    const [message, setMessage] = useState('');
    const {
        postDataAuth: changePassword,
        response: changePasswordResponse,
        data: changePasswordData,
        error: changePasswordError,
        isLoading: changePasswordIsLoading
      } = useController();

    const onSubmit = async data => {
        console.log(data);
        await changePassword( `${APP_SETTINGS.api}/Account/ChangePassword?Password=${data.password}`, token?.access_token);
     
    }
    useEffect(()=>{
        if(changePasswordResponse?.ok)
        {
            setMessage('Password succesfully changed')
        }
        return ()=>{
            setMessage('');
        }
    },[changePasswordData,changePasswordResponse])
    return (
        <Container>
            <Card>
                <Text role="h1">{lang?.changePassword}</Text>
                
                <Controller
                            name="password"
                            control={control}
                            rules={{
                                required: true,
                                pattern: {
                                    value: /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{8,}$/,
                                    message: lang?.passwordDoesNotMatchCriteria
                                }
                            }}

                            render={({ field }) => <><Input props={field} placeholder="Password" type="password" />
                                <PasswordStrengthBar password={field.value} /></>}
                        />

                        {errors.password && errors.password.type === "required" && (
                            <Text role="validationMessage">{lang?.passwordRequired}.</Text>
                        )}
                        {errors.password && errors.password.type !== "required" && (
                            <Text role="validationMessage">{errors.password.message}</Text>
                        )}
                        <Text role="subtitle">{lang?.useAMinimum}</Text>
                    <Controller
                        name="confirmPassword"
                        control={control}
                        rules={{ required: true, validate: (value) =>
                            value === getValues("password") || lang?.passwordDontMatch
                        }}
                        render={({ field }) => <Input type="password" placeholder={lang?.confirmNewPassword} props={field} />}
                    />
                    {errors.confirmPassword && <Text role="validationMessage" >{errors.confirmPassword?.message}</Text>}
                    <button style={{...Classes.Button.Secondary}} title="Log In" onClick={handleSubmit(onSubmit)}>
                        {lang?.edit}
                    </button>
                    <button style={{...Classes.Button.Secondary}} title="Close" onClick={()=> {setOpen(false)}}>
                        {lang?.close}
                    </button>
                    <p style={{color:'white'}}>{message != '' && message}</p>
            </Card>
        </Container>
    )
}